import { getCalculatePercentileAction, getEditApplicationAction } from './shared';
import type { CreateApplicationStageConfig } from './types';

export const createRejectedStageConfig: CreateApplicationStageConfig = actions => ({
  badge: { id: 'rejected', label: 'Rejected', color: 'info' },
  getAttributes: () => [],
  getActions: () => [getEditApplicationAction(actions), getCalculatePercentileAction(actions)],
  getActiveProcessesProps: () => ({
    collapsible: false,
    items: [
      {
        id: 'reject-candidate',
        title: 'Reject candidate',
        description: 'Contact the candidate and add all necessary details to the timeline, then close the application',
        action: {
          id: 'close-application',
          label: 'Close application',
          variant: 'contained',
          onClick: actions.closeApplication,
        },
      },
    ],
  }),
});
